<template>
    <b-col sm="12">
        <b-form-row class="busca-avancada">
            <b-col sm="2" v-if="lojas.length > 1">
                <loja :exibe_busca_todos="false" :filtro="buscaAvancada" :lojas="lojas" :multi="false" />
            </b-col>
            <b-col sm="2">
                <label for="nome">Número</label>
                <b-form-input id="nome" v-model="buscaAvancada.ide_nMDF"></b-form-input>
            </b-col>
            <b-col sm="1">
                <label for="nome">Série</label>
                <b-form-input id="nome" v-model="buscaAvancada.ide_serie"></b-form-input>
            </b-col>
            <b-col sm="7">
                <periodo 
                    :filtro="buscaAvancada"
                />
            </b-col>
            <b-col sm="3">
                <situacao :situacoes="situacoes" :buscaAvancada="buscaAvancada" />
            </b-col>
            <b-col sm="3">
                <label for="nome">Placa</label>
                <b-form-input id="nome" v-model="buscaAvancada.veicTracao_placa"></b-form-input>
            </b-col>
            <b-col sm="3">
                <label for="nome">Condutor</label>
                <b-form-input id="nome" v-model="buscaAvancada.condutor"></b-form-input>
            </b-col>
            <b-col sm="3">
                <label for="nome">Contratante</label>
                <b-form-input id="nome" v-model="buscaAvancada.contratante"></b-form-input>
            </b-col>
            <b-col sm="4">
                <municipio-carregamento :filtro="buscaAvancada" />
            </b-col>
            <b-col sm="4">
                <municipio-descarregamento :filtro="buscaAvancada" />
            </b-col>
            <b-col sm="4">
                <label for="nome">Seguradora</label>
                <b-form-input id="nome" v-model="buscaAvancada.seguradora"></b-form-input>
            </b-col>
        </b-form-row>
    </b-col>
</template>
<script>
import Loja from './Filtros/Loja'
import Periodo from './Filtros/Periodo'
import Situacao from './Filtros/Situacao'
import MunicipioCarregamento from './Filtros/MunicipioCarregamento'
import MunicipioDescarregamento from './Filtros/MunicipioDescarregamento'

export default {
    components: {
        Loja,
        Periodo,
        Situacao,
        MunicipioCarregamento,
        MunicipioDescarregamento
    },
    props: {
        buscaAvancada: {
            default: () => {}
        },
        lojas: {
            default: () => []
        },
        data: {
            default: null
        }
    },
    data() {
        return {
            situacoes: []
        }
    },
    mounted() {
        let situacoes = []
        this.data.situacoes_mdfe.forEach((item, index) => {
            situacoes.push({
                text: item.nome,
                value: index
            })
        })
        this.situacoes = situacoes
    }
}
</script>
